// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"h5-z","dimensionLabel":"i5-z","styleChooserControlWrapper":"j5-z","styleChooserControl":"k5-z","disabled":"l5-z","giftCard":"m5-z","styleChooserText":"n5-z"};